import { computed } from 'vue';
import { useStore } from 'vuex';

const usePermission = () => {
  const store = useStore();

  const allPermissions = computed(() => store.getters.currentUser.permissions);
  const canConfirmBbgt = computed(() => store.getters.canConfirmBbgt);
  const canDuyetVatTu = computed(() => store.getters.canDuyetVatTu);
  const canDuyetPnk = computed(() => store.getters.canDuyetPnk);
  const canDuyetPxk = computed(() => store.getters.canDuyetPxk);
  const canDuyetBbgt = computed(() => store.getters.canDuyetBbgt);
  const roles = computed(() => store.getters.roles);

  return {
    allPermissions,
    canConfirmBbgt,
    canDuyetBbgt,
    canDuyetVatTu,
    canDuyetPnk,
    canDuyetPxk,
    roles
  };
};

export default usePermission;
